import type { AppCopy } from '../catalogs';

export const etAppCopy = {
  welcomeHeading: 'Kuidas saan teid täna aidata?',
  thinking: 'Mõtlemine',
  scrollToBottom: 'Kerige alla',
  reasoning: 'Arutluskäik',
  reasoningInProgress: 'pooleli',
  citationPages: 'Leheküljed {first}–{last}',
  citationTitle: 'Allika väljavõte',
  citationLoading: 'Allika laadimine…',
  citationUnavailable: 'Viidatud tekst pole saadaval või sul pole enam juurdepääsu.',
  citationOpen: 'Ava allikas',
  citationCopied: 'Viide kopeeritud',
  copy: 'Kopeeri',
  more: 'Rohkem',
  tryAgain: 'Proovi uuesti',
  answerTruncated: 'Vastus jõudis pikkuse piirini ja katkes.',
  continueAnswer: 'Jätka vastust',
  exportMarkdown: 'Ekspordi kui Markdown',
  edit: 'Muuda',
  cancel: 'Tühista',
  update: 'Värskenda',
  previous: 'Eelmine',
  next: 'Edasi',
  messagePlaceholder: 'Saada sõnum…',
  projectHomePlaceholder: 'Uus vestlus: {project}',
  sharedChatEveryone: 'Kõik ettevõttes {company} saavad seda vestlust lugeda',
  sharedChatOnePerson: '1 inimene saab seda vestlust lugeda',
  sharedChatPeople: '{count} inimest saavad seda vestlust lugeda',
  forkedChatPlaceholder: 'Jätka oma ühendustega…',
  newAnswer: 'Uus vastus',
  messageInput: 'Sõnumi sisestus',
  sendMessage: 'Saada sõnum',
  stopGenerating: 'Lõpetage genereerimine',
  addAttachment: 'Lisa manus',
  removeFile: 'Eemalda fail',
  attachmentPreview: 'Manuse eelvaade',
  imageAttachmentPreview: 'Pildimanuse eelvaade',
  image: 'Pilt',
  openLink: 'ava link',
  document: 'Dokument',
  file: 'Fail',
  attachment: 'manus',
  uploadFailed: 'üleslaadimine ebaõnnestus',
  uploading: 'üleslaadimine',
  toolIncomplete: 'Lõpetamata',
  toolActivity: 'Tegevus',
  activityThinking: 'Mõtleb…',
  activityWriting: 'Kirjutab…',
  activityWaiting: 'Ootab teie kinnitust',
  activityStopped: 'Peatatud',
  activityCouldNotFinish: 'Ei õnnestunud lõpetada',
  activitySources: 'allikat',
  activityShowThinking: 'Näita mõtlemist',
  activityOpen: 'Ava tegevus',
  activitySteps: 'Sammud',
  activitySourcesTab: 'Allikad',
  activityUnavailable: 'See tegevus pole saadaval.',
  activityInput: 'Sisend',
  activityOutput: 'Väljund',
  activityNoSources: 'See vastus ei viidanud allikatele.',
  activityApprovedByReply: 'Kinnitatud teie vastusega',

  toolRunning: 'Töötab',
  toolComplete: 'Valmis',
  toolNeedsApproval: 'Vajab heakskiitu',
  toolInput: 'Sisend',
  toolCall: 'tööriistakõne',
  toolCalls: 'tööriistakõned',
  openMenu: 'Ava menüü',
  closeMenu: 'Sule menüü',
  close: 'Sule',
  showInTextField: 'Kuva tekstiväljal',
  settings: 'Seaded',
  appearance: 'Välimus',
  themeLight: 'Hele',
  themeDark: 'Tume',
  themeSystem: 'Süsteem',
  themeChoiceHelp:
    'Kehtib kõigis sinu seadmetes. Süsteem järgib iga seadme heledat või tumedat režiimi.',
  themeSaveFailed: 'Välimust ei õnnestunud salvestada, seega see jäi muutmata. Proovi uuesti.',
  toolUsed: 'Kasutatud tööriist',
  toolCancelled: 'Tühistatud tööriist',
  toolResult: 'Tulemus:',
  toolError: 'Viga:',
  toolCancelledReason: 'Tühistatud põhjus:',
  approvalAllow: 'Luba',
  approvalAlwaysAllow: 'Lubage alati',
  approvalDeny: 'Keela',
  approvalAlwaysDeny: 'Keela alati',
  approvalConfirm: 'Kinnita',
  approvalBack: 'Tagasi',
  approvalApprovedResult: 'Kasutaja poolt heaks kiidetud',
  approvalDeniedResult: 'Kasutaja keelas tööriista täitmise',
  logout: 'Logi välja',
  loginOrCreateAccount: 'Logi sisse / Loo konto',
  newChat: 'Uus vestlus',
  untitledChat: 'Pealkirjata vestlus',
  previousChats: 'Eelmised vestlused',
  openChat: 'Avage vestlus {title}',
  moreActionsForChat: 'Rohkem toiminguid {title} jaoks',
  chatActions: 'Vestlustoimingud',
  closeChatActions: 'Sule vestlustoimingud',
  deleteChatQuestion: 'Kas kustutada vestlus?',
  deleteChatDescription: 'Vestlus "{title}" kustutatakse jäädavalt.',
  deleteChat: 'Kustuta vestlus',
  keepChat: 'Säilita vestlus',
  delete: 'Kustuta',
  deleting: 'Kustutamine…',
  chatDeleteFailed: 'Vestlust ei saanud kustutada. Proovi uuesti.',
  settingsDescription: 'Kohandage, kuidas assistent teie jaoks töötab.',
  settingsDesktopDescription: 'Kohandage, kuidas assistent teile vastab.',
  personalization: 'Isikupärastamine',
  personalizationDescription: 'Kohandage juhiseid, mida assistent iga vastuse puhul järgib.',
  languageAndRegion: 'Keel ja piirkond',
  languageAndRegionDescription: 'Valige keel ja ajavöönd.',
  memories: 'Mälestused',
  memoriesDescription: 'Vaadake, muutke või kustutage seda, mida assistent teie kohta mäletab.',
  account: 'konto',
  accountDescription: 'Hallake kontot ja kustutage oma andmed jäädavalt.',
  backToSettings: 'Tagasi seadete juurde',
  closeSettings: 'Sulge seaded',
  settingsCategories: 'Seadete kategooriad',
  yourSettings: 'Teie seaded',
  dataAndAccount: 'Andmed ja konto',
  viewAndManageMemories: 'Vaadake ja hallake, mida assistent mäletab',
  loginToUseMemories: 'Mälude kasutamiseks logige sisse',
  manageOrDeleteAccount: 'Konto haldamine või kustutamine',
  unsavedChanges: 'Teil on salvestamata muudatusi',
  unsavedCloseDescription: 'Seadete sulgemisel tühistatakse sellel lehel tehtud muudatused.',
  unsavedBackDescription: 'Tagasi minnes tühistatakse sellel lehel tehtud muudatused.',
  continueEditing: 'Jätkake redigeerimist',
  discardChanges: 'Loobu muudatustest',
  saveChanges: 'Salvestage muudatused',
  localSettingsNote: 'Salvestatud selles brauseris. Oma kontole salvestamiseks logige sisse.',
  personality: 'Isiksus',
  personalityHelp: 'Kohandatud juhised, mida assistent järgib igas vastuses',
  personalityPlaceholder:
    'Näiteks: Olge lühike ja konkreetne. Ma elan Göteborgis ja mulle meeldib taimetoit.',
  timezone: 'Ajavöönd',
  searchTimezone: 'Otsi ajavööndeid…',
  automaticBrowser: 'Automaatne (brauser)',
  saved: 'Salvestatud {date}',
  addMemory: 'Lisa mälestus',
  newMemory: 'Uus mälestus',
  memoryPlaceholder: 'Näiteks: Eelistan lühikesi ja konkreetseid vastuseid.',
  editMemory: 'Muuda mälestust',
  saveMemory: 'Salvesta mälestus',
  deleteMemory: 'Kustuta mälestus',
  memorySaveFailed: 'Mälu ei õnnestunud salvestada. Proovi uuesti.',
  memoryLimitReached: 'Saad salvestada kuni 50 mälestust. Kustuta üks enne uue lisamist.',
  memoryInvalid: 'Mälestused ei tohi sisaldada linke. Eemalda link ja proovi uuesti.',
  memoryDeleteFailed: 'Mälu ei saanud kustutada. Proovi uuesti.',
  memoryLoadFailed: 'Mälestusi ei saanud laadida.',
  loadingMemories: 'Mälestuste laadimine…',
  emptyMemories:
    'Assistent salvestab rääkimise ajal teie kohta mälestusi – mis teile meeldib, kus elate ja millega tegelete. Siin saate neid vaadata, muuta ja kustutada.',
  deleteAccountHelp:
    'Kustutage jäädavalt konto ja kõik sellega seotud vestlused, mälestused ja seaded.',
  deleteAccount: 'Kustuta konto',
  deleteAccountQuestion: 'Kas kustutada konto jäädavalt?',
  deleteAccountDescription:
    'Kõik vestlused, sõnumid, mälestused, seaded ja sisselogimismandaadid kustutatakse. Seda toimingut ei saa tagasi võtta.',
  deleteAccountConfirm: 'Jah, kustuta mu konto',
  accountDeleteFailed: 'Kontot ei saanud kustutada. Midagi ei eemaldatud – proovige uuesti.',
  logoutEverywhereTitle: 'Kõik seadmed',
  logoutEverywhereHelp:
    'Logige välja kõigis seadmetes ja brauserites, kus teie konto on avatud, ka selles.',
  logoutEverywhere: 'Logi kõikjal välja',
  logoutEverywhereQuestion: 'Kas logida välja kõigis seadmetes?',
  logoutEverywhereDescription:
    'Peate uuesti sisse logima kõigis seadmetes ja brauserites, ka selles. Teie vestlused ja seaded jäävad samaks.',
  loggingOut: 'Väljalogimine…',
  logoutEverywhereFailed:
    'Me ei saanud kinnitada, et teid kõikjal välja logiti. Proovige uuesti või kontrollige mõnes teises seadmes, kas olete endiselt sisse logitud.',
  settingsSaveFailed: 'Seadeid ei saanud salvestada. Proovi uuesti.',
  customInstructions: 'Kohandatud juhised',
  notSet: 'Pole määratud',
  automaticLanguage: 'Automaatne keel',
  automaticTimezone: 'automaatne ajavöönd',
  appLanguage: 'Rakenduse keel',
  appLanguageHelp:
    'Juhib kogu rakenduse liidest ja kuupäevi. Assistendi vastused järgivad endiselt keelt, milles kirjutate.',
  automaticBrowserLanguage: 'Automaatne (brauseri keel)',
  previousLanguageChoice: 'Eelmine valik: {language} ({locale})',
  previousLanguageChoiceCode: 'Eelmine valik ({locale})',
  canvasCopyLink: 'Kopeeri link',
  canvasLinkCopied: 'Link on kopeeritud',
  actionUpdatedWithEdits: 'Uuendatud teie muudatustega',
  activityStepsDone: 'one:samm tehtud|other:sammu tehtud',
  activityResultsCount: 'one:tulemus|other:tulemust',
  canvasCopyLinkFailed: 'Linki ei õnnestunud kopeerida',
  canvasOpenInAgent: 'Ava rakenduses {agent}',
  canvasExpand: 'Laienda',
  canvasExitFullView: 'Välju täisvaatest',
  webSourceUnread:
    'Lingitud selles vastuses. Poneva ei lugenud seda lehte, seega pole siin midagi näidata.',
  webSourceOpenOriginal: 'Ava algallikas',
  toolProgressSettings: 'Teie seadete muutmine…',
  toolProgressAgent: 'Agendi loomine…',
  toolProgressConnections: 'Ühendusvalikute otsimine…',
  toolProgressResult: 'Teie tulemuse ettevalmistamine…',
  toolProgressClarification: 'Täpsustuse ettevalmistamine…',
  toolProgressKnowledge: 'Soovitatud teadmiste uuenduse ettevalmistamine…',
  toolProgressQuestion: 'Teile küsimuse ettevalmistamine…',
  toolProgressSkill: 'Kujundame teie Skilli…',
  toolErrorSettings: 'Teie seadeid ei muudetud.',
  toolErrorAgent: 'Agenti ei õnnestunud luua.',
  toolErrorConnections: 'Ühendusvalikuid ei õnnestunud laadida.',
  toolErrorResult: 'Tulemust ei salvestatud.',
  toolErrorClarification: 'Täpsustust ei õnnestunud ette valmistada.',
  toolErrorKnowledge: 'Soovitatud teadmiste uuendust ei õnnestunud ette valmistada.',
  toolErrorQuestion: 'Küsimust ei õnnestunud ette valmistada.',
  toolErrorSkill: 'Skilli mustandit ei õnnestunud salvestada.',
  toolErrorOpenSettings: 'Ava seaded',
  toolErrorOpenAgents: 'Ava agendid',
  toolErrorOpenConnections: 'Ava ühendused',
  toolStepIncomplete: 'See samm jäi lõpetamata.',
  toolEarlierAttemptsFailed: 'one:varasem katse ei õnnestunud|other:varasemat katset ei õnnestunud',
} satisfies AppCopy;
